import { Button, Card, Checkbox, FormControlLabel, Grid2, TextField } from "@mui/material";
import React from "react";

import Tag from "components/common/Tag";
import { actions } from "components/settings/tags/logic/actions";
import PropTypes from "prop-types";
import { ChromePicker } from "react-color";
import { connect } from "react-redux";

import "./styles.scss";

const SettingsTagForm = ({ tag: { value, color, deleted }, changeForm, createTag }) => {
    const saveTag = () => {
        createTag();
    };

    return (
        (<Grid2 container className="settings-tag-form">
            <Card variant="outlined">
                <Grid2 container  size={12}>
                    <Grid2 size={12}>
                        <TextField
                            label="Name"
                            margin="normal"
                            variant="outlined"
                            name="tagName"
                            value={value}
                            onChange={(e) => changeForm({ attribute: "value", value: e.target.value })}
                        />
                        <ChromePicker
                            color={color}
                            onChangeComplete={(color) => changeForm({ attribute: "color", value: color.hex })}
                            disableAlpha
                        />
                        <Grid2 style={{ paddingRight: 5, marginTop: 20 }} size={12}>
                            <span style={{ margin: "5px 15px 15px 0", display: "inline-block" }}>Preview:</span>
                            <Tag name={value} color={color} />
                        </Grid2>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={deleted}
                                    onChange={(e) => changeForm({ attribute: "deleted", value: e.target.checked })}
                                    inputProps={{ "aria-label": "select all desserts" }}
                                />
                            }
                            label="Disabled"
                        />
                    </Grid2>
                    <Grid2
                        size={{
                            xs: 12,
                            md: 6
                        }}>
                        {}
                    </Grid2>
                    <Grid2 style={{ display: "flex", margin: "15px 0" }} size={12}>
                        <Button variant={"outlined"} size={"small"} color={"primary"} onClick={saveTag}>
                            Add Tag
                        </Button>
                    </Grid2>
                </Grid2>
            </Card>
        </Grid2>)
    );
};

SettingsTagForm.propTypes = {
    tag: PropTypes.shape({
        value: PropTypes.string,
        color: PropTypes.string,
        deleted: PropTypes.bool,
    }),
    changeForm: PropTypes.func,
    createTag: PropTypes.func,
};
const mapStateToProps = ({ tagSettings }) => ({
    tag: tagSettings.tagForm,
});

const mapDispatchToProps = (dispatch) => {
    return {
        changeForm: (payload) => dispatch(actions.CHANGE_TAG_FORM.call(payload)),
        createTag: () => dispatch(actions.CREATE_TAG.send()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsTagForm);
